import React from 'react';
import { faRegularRectangleHistorySlash } from '@awesome.me/kit-2cbcf7d4a0/icons/kit/custom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';

interface ToggleShowHistoryIconProps {
    showHistory: boolean;
}
const ToggleShowHistoryIcon = ({ showHistory }: ToggleShowHistoryIconProps) => {
    return (
        <div className={cn('k-d-flex fa-stack', showHistory ? 'k-text-secondary' : '')}>
            <FontAwesomeIcon
                fontSize={16}
                icon={showHistory ? ['far', 'rectangle-history'] : faRegularRectangleHistorySlash}
            />
        </div>
    );
};
export default ToggleShowHistoryIcon;
